import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, filter, first, map, of } from 'rxjs';
import { Store } from '@ngxs/store';
import { AppEnvironmentState, UserState } from '../state';
import { Environment } from '../model';
import { ApiService } from './api.service';
import * as i0 from "@angular/core";
export class MonitoringService {
  injector;
  appName$ = new BehaviorSubject(undefined);
  api;
  store;
  constructor(injector) {
    this.injector = injector;
    this.api = injector.get(ApiService);
    this.store = injector.get(Store);
  }
  set appName(appName) {
    this.appName$.next(appName);
  }
  sendTrackEvent(component, method) {
    combineLatest([this.store?.select(UserState.authState) ?? of("not set" /* AuthState.NotSet */), this.appName$]).pipe(filter(([authState, appName]) => authState === "logged in" /* AuthState.LoggedIn */ && appName !== undefined), map(([, appName]) => appName), first(), filter(appName => !!appName), map(appName => this.createMonitoringData(appName, component, method)), filter(monitoringData => !!monitoringData)).subscribe(monitoringData => this.pushLogs(monitoringData));
  }
  pushLogs(monitoringData) {
    this.api?.post('logging-api/logs', monitoringData).subscribe();
  }
  createMonitoringData(appName, component, method) {
    const env = this.store?.selectSnapshot(AppEnvironmentState.appEnvironmentState).environment;
    if (!env || env === Environment.LOCAL) {
      return null;
    }
    return {
      app: 'digital-ui-library',
      source: appName,
      message: `Component: ${component}, Method: ${method}`,
      logLevel: 'INFO',
      env: env
    };
  }
  static ɵfac = function MonitoringService_Factory(t) {
    return new (t || MonitoringService)(i0.ɵɵinject(i0.Injector));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MonitoringService,
    factory: MonitoringService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonitoringService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i0.Injector
  }], null);
})();
